import useEventBus from 'hooks/useEventBus';
import React, { memo, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import { Header, HoursPack, Services, StatusControl } from './components';

import * as Styles from './styles';

interface IProps extends RouteComponentProps {}

const BudgetControlComponent: React.FC<IProps> = ({ history }) => {
  const eventBus = useEventBus();
  useEffect(() => {
    eventBus.dispatchEvent('onChangeTitle', 'Controle orçamentário');
    return () => {
      eventBus.dispatchEvent('onChangeTitle', '');
    };
  }, []);
  return (
    <Styles.Container>
      <Header history={history} />

      <HoursPack history={history} />

      <StatusControl history={history} />

      <Services history={history} />
    </Styles.Container>
  );
};

export const BudgetControl = memo(BudgetControlComponent);
